import Modal from 'react-modal';

/**
 * react-modal paints every dialog that brings no className of its own on an
 * inline white box with a grey border. The dialog bodies that rely on it (slip
 * confirm/success, live odds review, login, info) never set a background, so on
 * the dark palettes their light text landed on white.
 *
 * Route the box through theme tokens instead. tokens.css defaults them to
 * react-modal's own #fff / #ccc, so the light palettes are unchanged, and
 * themes.css re-points them at the card surface for dark palettes. Dialogs that
 * pass a className (full-screen loaders, change password) never get this box.
 */
Modal.defaultStyles = {
  ...Modal.defaultStyles,
  content: {
    ...Modal.defaultStyles.content,
    background: 'var(--theme-modal-bg)',
    border: '1px solid var(--theme-modal-border)',
  },
};
